(function ($) {
    $.fn.simpleAccordion = function (options) {
        var defaults = {
            item: '.accordion__div',
            title: '.accordion__title',
            content: '.accordion__content',
            activeClass: 'is-active',
            duration: 300,
            easing: 'swing',
            collapsible: true, // 같은 항목 클릭 시 접기 허용
            showOnly: true, // 하나만 열리게
            breakpoint: null, // ex) 768
            onOpen: function ($item) {},
            onClose: function ($item) {},
        };

        var settings = $.extend({}, defaults, options);

        return this.each(function () {
            var $accordion = $(this);
            var $items = $accordion.find(settings.item);
            var initialized = false;

            function bindEvents() {
                $items.each(function () {
                    var $item = $(this);
                    var $title = $item.find(settings.title).first();
                    var $content = $item.find(settings.content).first();

                    if (!$item.hasClass(settings.activeClass)) {
                        $content.hide();
                    }

                    $title
                        .css('cursor', 'pointer')
                        .off('click.simpleAccordion')
                        .on('click.simpleAccordion', function () {
                            var isOpen = $item.hasClass(settings.activeClass);

                            if (isOpen && settings.collapsible) {
                                $item.removeClass(settings.activeClass);
                                $content.stop().slideUp(settings.duration, settings.easing, function () {
                                    settings.onClose($item);
                                });
                                return;
                            }

                            if (settings.showOnly) {
                                $items
                                    .not($item)
                                    .removeClass(settings.activeClass)
                                    .find(settings.content)
                                    .stop()
                                    .slideUp(settings.duration, settings.easing, function () {
                                        settings.onClose($(this).closest(settings.item));
                                    });
                            }

                            if (!isOpen) {
                                $item.addClass(settings.activeClass);
                                $content.stop().slideDown(settings.duration, settings.easing, function () {
                                    settings.onOpen($item);
                                });
                            }
                        });
                });
                initialized = true;
            }

            function unbindEvents() {
                $items.each(function () {
                    var $item = $(this);
                    var $title = $item.find(settings.title).first();
                    var $content = $item.find(settings.content).first();

                    $title.off('click.simpleAccordion').removeAttr('style');
                    $content.removeAttr('style');
                    $item.removeClass(settings.activeClass);
                });
                initialized = false;
            }

            function checkResponsive() {
                if (settings.breakpoint && window.innerWidth >= settings.breakpoint) {
                    if (initialized) unbindEvents();
                } else {
                    if (!initialized) bindEvents();
                }
            }

            checkResponsive();
            $(window).on('resize.simpleAccordion', checkResponsive);
        });
    };

    $('.terms__accordion').simpleAccordion({
        showOnly: false,
        breakpoint: 960
    });
})(jQuery);
